import ApiBase from 'app/services/api/entities/Base'

function* all(params = {}) {
  return yield ApiBase.privateGet('/v1/mlm/tentative_parents/', {
    params
  })
}

function* search(searchTerm) {
  return yield ApiBase.privateGet('/v1/mlm/tentative_parents/search/', {
    params: { search: searchTerm }
  })
}

function* remove(agentId) {
  return yield ApiBase.privatePost(`/v1/mlm/tentative_parents/remove/${agentId}/`)
}

function* choose(agentId) {
  return yield ApiBase.privatePost(`/v1/mlm/tentative_parents/choose/${agentId}/`)
}

export default {
  all,
  search,
  remove,
  choose,
}
